module.exports = __webpack_public_path__ + "static/mens-health-7782fef39fc19b75ac7950048a7f1073.png";